import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgC1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 230,
	viewBox: "0 0 170 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6073_224)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 170,
					height: 230,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.285 143.8C61.2717 143.8 57.005 142.973 53.485 141.32C50.0183 139.613 47.325 137.16 45.405 133.96C43.485 130.707 42.4183 126.76 42.205 122.12C42.1517 119.933 42.125 117.587 42.125 115.08C42.125 112.573 42.1517 110.173 42.205 107.88C42.4183 103.293 43.485 99.4 45.405 96.2C47.3783 92.9467 50.125 90.4667 53.645 88.76C57.165 87.0533 61.3783 86.2 66.285 86.2C69.8583 86.2 73.1117 86.6533 76.045 87.56C78.9783 88.4667 81.5117 89.7733 83.645 91.48C85.7783 93.1867 87.4317 95.1867 88.605 97.48C89.7783 99.7733 90.4183 102.333 90.525 105.16C90.525 105.64 90.3383 106.04 89.965 106.36C89.645 106.68 89.245 106.84 88.765 106.84H79.645C79.005 106.84 78.4983 106.68 78.125 106.36C77.7517 106.04 77.4583 105.507 77.245 104.76C76.445 101.613 75.1117 99.4533 73.245 98.28C71.3783 97.1067 69.0583 96.52 66.285 96.52C62.9783 96.52 60.365 97.4267 58.445 99.24C56.525 101.053 55.485 104.067 55.325 108.28C55.165 112.653 55.165 117.133 55.325 121.72C55.485 125.933 56.525 128.947 58.445 130.76C60.365 132.573 62.9783 133.48 66.285 133.48C69.0583 133.48 71.3783 132.893 73.245 131.72C75.165 130.493 76.4983 128.333 77.245 125.24C77.4583 124.44 77.7517 123.907 78.125 123.64C78.4983 123.32 79.005 123.16 79.645 123.16H88.765C89.245 123.16 89.645 123.32 89.965 123.64C90.3383 123.96 90.525 124.36 90.525 124.84C90.4183 127.667 89.7783 130.227 88.605 132.52C87.4317 134.813 85.7783 136.813 83.645 138.52C81.5117 140.227 78.9783 141.533 76.045 142.44C73.1117 143.347 69.8583 143.8 66.285 143.8ZM115.754 143C115.22 143 114.74 142.813 114.314 142.44C113.94 142.067 113.754 141.587 113.754 141V101.24L102.234 110.12C101.754 110.493 101.247 110.627 100.714 110.52C100.234 110.413 99.8071 110.12 99.4338 109.64L95.4338 104.44C95.1138 103.96 94.9804 103.453 95.0338 102.92C95.1404 102.387 95.4338 101.96 95.9138 101.64L114.154 87.56C114.474 87.3467 114.767 87.2133 115.034 87.16C115.354 87.0533 115.7 87 116.074 87H124.554C125.087 87 125.54 87.1867 125.914 87.56C126.287 87.9333 126.474 88.4133 126.474 89V141C126.474 141.587 126.287 142.067 125.914 142.44C125.54 142.813 125.087 143 124.554 143H115.754Z",
					fill: "#E2330A"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48.5,
					cy: -15.5,
					r: 56.5,
					fill: "#ED8B88"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 79.5,
					cy: 240.5,
					r: 59.5,
					fill: "#ED8B88"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 169,
			height: 229,
			rx: 7.5,
			stroke: "#BBBFC7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6073_224",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 170,
				height: 230,
				rx: 8,
				fill: "white"
			})
		}) })
	]
});
export default SvgC1;
